import "./Footer.css";
import logo from "../assets/kemarilogohero.png";
import { useLocation, useNavigate } from "react-router-dom";

const links = [
  { label: "About",   id: "about" },
  { label: "Team",    id: "team" },
  { label: "Contact", id: "contact" },
];

const contact = [
  { label: "(032) 384-3864" },
  { label: "0917 138 3790" },
  { label: "kemari.hr@gmail.com" },
];

function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollTo = (id) => {
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="ft-root">
      <div className="ft-divider" />

      <div className="ft-inner">

        <div className="ft-brand">
          <img src={logo} alt="Kemari" className="ft-logo" />
          <p className="ft-tagline">
            Systems integration for<br />smarter, safer environments.
          </p>
        </div>

        <div className="ft-col">
          <p className="ft-col-label">Navigate</p>
          <ul className="ft-list">
            {links.map((l) => (
              <li key={l.label}>
                <button
                  onClick={() => scrollTo(l.id)}
                  className="ft-link"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="ft-col">
          <p className="ft-col-label">Contact</p>
          <ul className="ft-list">
            {contact.map((c) => (
              <li key={c.label} className="ft-text">{c.label}</li>
            ))}
          </ul>
        </div>

        <div className="ft-col">
          <p className="ft-col-label">Location</p>
          <p className="ft-text ft-address">
            3rd Floor Legazpi Commercial Bldg.<br />
            Tunghaan, Minglanilla, Cebu
          </p>
        </div>

      </div>

      <div className="ft-bottom">
        <span className="ft-copy">© 2025 Kemari. All rights reserved.</span>
      </div>
    </footer>
  );
}

export default Footer;